// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5fe8eba2","239":"fb436b3c","732":"9244b010"}[chunkId] + ".chunk.js";
};